export function isObject(value) {
    return value !== null && typeof value === "object" && !(value instanceof Date);
}
//# sourceMappingURL=isObject.js.map